<template>
  <div
    class="dropdown-wrapper enext-input"
    :class="[
      rules && rules.length ? 'enext-input--validable' : '',
      errorMessage ? 'invalid' : '',
      $attrs?.class ? $attrs.class : ''
    ]"
  >
    <kendo-dropdownlist
      class="dropdown k-dropdown"
      v-bind="customAttrs"
      @filterchange="filterChange"
      @open="onOpen"
      @close="onClose"
      @change="onChange"
      :icon-class-name="iconClassName"
      :data-items="items"
      :popup-settings="popupSettings"
      ref="dropdownlist"
    >
      <template
        v-for="(_, slot) of $slots"
        #[slot]="scope"
      >
        <slot
          :name="slot"
          v-bind="scope"
        />
      </template>
    </kendo-dropdownlist>
    <ErrorMessage
      :error-message="errorMessage"
      class="enext-input__errormessage"
      ref="errormessage"
    />
  </div>
</template>

<script>
import {DropDownList} from '@progress/kendo-vue-dropdowns'
import {useDropdown} from '~/composables/useDropdown'
import ErrorMessage from '~/components/input-components/ErrorMessage'

export default {
  name: 'DropDown',
  components: {
    ErrorMessage,
    'kendo-dropdownlist': DropDownList
  },
  props: {
    skipClientFilter: {
      type: Boolean,
      default: () => false
    },
    iconClassName: {
      type: String,
      default() {
        return 'k-i-arrow-chevron-down'
      }
    },
    rules: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    popupClassName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  setup(props, {attrs}) {
    const dropdown = useDropdown({
      getDataItems: () => attrs['data-items'],
      getAttrs: () => attrs,
      rules: props.rules,
      skipClientFilter: props.skipClientFilter
    })

    const popupSettings = {animate: true, className: props.popupClassName}

    return {
      ...dropdown,
      popupSettings
    }
  },
  computed: {
    customAttrs() {
      let attrs = {...this.$attrs, class: ''}
      return attrs
    }
  },
  mounted() {
    this.patchSingleItemFocus()
  },
  methods: {
    patchSingleItemFocus() {
      const ddl = this.$refs.dropdownlist
      if (!ddl || typeof ddl.focusedIndex !== 'function') {
        return
      }
      const originalFocusedIndex = ddl.focusedIndex.bind(ddl)
      ddl.focusedIndex = () => {
        const dataItems = ddl.$props?.dataItems ?? []
        if (dataItems.length === 1) {
          return 0
        }
        return originalFocusedIndex()
      }
    },
    close() {
      this.$refs.dropdownlist.handleKeyDown(new KeyboardEvent('keypress', {'keyCode': 27}))
    },
    onChange(e) {
      // run custom function onClick when its set
      const val = e.value || e.target.value
      // eslint-disable-next-line eqeqeq
      if (val?.onClick && typeof val.onClick === 'function') {
        val.onClick()
      }
    }
  }
}
</script>
